import { useQuery } from 'hooks/useCustomQuery';
import { getWholesalerServiceProfiles } from 'API/ServiceProfiles/getAllServiceProfiles';

const useGetWholesalerServiceProfiles = ({ wholesalerID, enabled = true }) => {
    return useQuery({
        queryKey: ['serviceProfiles', 'wholesaler', wholesalerID],
        queryFn: () => getWholesalerServiceProfiles({ wholesalerID }),
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: enabled && !!wholesalerID,
        select: (res) => res.data,
    });
};

export default useGetWholesalerServiceProfiles;
